import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Loader,
  Cookies,
} from '@resy/ui-kitchen';

import {
  GDA_COOKIE_NAME, GDA_ELIGIBLE, GDA_MEMBER, NEW_EVENTS, MAIN_EVENTS, handleTaggingWithProps,
  updatedEventsData, validateEventsSectionData,
  updateResyEventItem, updateWithCommonFields, getCurrentMomentDate, DATE_TIME_FORMAT, findNewEvents, DATE_TIME_FORMAT_EVENT,
  PAST_EVENTS,
} from './ExperientialEvents';
import { scrollTo, fetchS3JsonFile } from '../AmexMarketingUtils/AmexUtils';
import AmexHeader from '../AmexMarketingUtils/AmexHeader';
import AmexExperientialBanner from './AmexExperientialBanner';
import AmexExperientialEvents from './AmexExperientialEvents';
import AmexExperientialHeader from './AmexExperientialHeader';
import AmexMarketingEditorials from '../AmexMarketingUtils/AmexMarketingEditorials';
import AmexExperientialEmailOptIn from './AmexExperientialEmailOptIn';
import AmexExperientialMGM from './AmexExperientialMGM';
import AmexExperientialNAA from './AmexExperientialNAA';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import { selectIsGlobalDiningAccess } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import './AmexExperiential.scss';

class AmexExperiential extends React.Component {
  static propTypes = {
    $rootScope: PropTypes.shape({
      $broadcast: PropTypes.func,
      isScrolled: PropTypes.bool,
      nav: PropTypes.shape(),
      previewMode: PropTypes.bool,
      $digest: PropTypes.func,
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        ipadLandscape: PropTypes.bool,
        xl: PropTypes.bool,
      }),
      locationCode: PropTypes.string,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isUserLoggedInAsGDA: PropTypes.bool.isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({
      event: PropTypes.func,
    }).isRequired,
    $location: PropTypes.shape({
      path: PropTypes.func,
      search: PropTypes.func.isRequired,
    }).isRequired,
    $routeParams: PropTypes.shape({}).isRequired,
    selectedCoreSeats: PropTypes.number.isRequired,
    selectedCoreISODate: PropTypes.string.isRequired,
    selectedCoreTime: PropTypes.string.isRequired,
    locationBySlug: PropTypes.shape({}).isRequired,
    selectedLocation: PropTypes.shape({
      url_slug: PropTypes.string,
    }).isRequired,
    locationByCode: PropTypes.shape({}).isRequired,
    allLocations: PropTypes.shape({}).isRequired,
    isNonUS: PropTypes.bool.isRequired,
  }

  state = {
    contentData: null,
    gdaCookie: '',
    parsedEventsData: null,
    newEvents: null,
    pastEvents: null,
    editorialData: {},
    filteredEditorialsListLength: 1,
    hash: null,
    showAllEnabled: false,
    isFilterEnabled: false,
  }

  componentDidMount() {
    const currentHash = (window.location.hash).replace('#', '');
    window.location.hash = '';
    window.addEventListener('hashchange', this.handleHashChange, false);
    this.fetchData(currentHash);
    this.setGDAPageCookie();
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime,
      locationBySlug,
    } = this.props;

    const {
      eventsData,
      contentData,
      showAllEnabled,
      hash,
    } = this.state;

    const deepLinksTimeout = contentData?.deep_links_timeout || 1500;

    if (prevState.hash !== hash) {
      window.location.hash = `#${hash}`;
      if (hash) {
        setTimeout(() => {
          scrollTo(`#${hash}`);
        }, deepLinksTimeout);
      }
    }

    if (Object.keys(locationBySlug).length > 0
    && (prevProps.selectedCoreSeats !== selectedCoreSeats
      || prevProps.selectedCoreISODate !== selectedCoreISODate
      || prevProps.selectedCoreTime !== selectedCoreTime
      || prevProps.locationBySlug !== locationBySlug
      || prevState.eventsData !== eventsData
      || prevState.contentData !== contentData)) {
      let updatedEvents = null;
      if (contentData && validateEventsSectionData(contentData?.events)) {
        updatedEvents = await updatedEventsData(eventsData, contentData.events,
          selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug, showAllEnabled);
        const {
          include_new_events: includeNewEvents,
        } = contentData?.events;

        const newEvents = findNewEvents(contentData, updatedEvents);
        updatedEvents = updatedEvents.filter((eventItem) => !eventItem.display_tile);
        if (!includeNewEvents) {
          updatedEvents = updatedEvents.filter((eventItem) => !eventItem.isNewEvent);
        }
        this.updateEventsDataState(updatedEvents, newEvents);
        if (contentData?.events?.section_id === hash) scrollTo(`#${hash}`);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false);
  }

  findEventLocations = (updatedEvents, locationBySlug) => {
    const eventsLocations = [];
    updatedEvents?.forEach((updatedEventItem) => {
      const location = locationBySlug[updatedEventItem?.location];
      if (eventsLocations.includes(location) === false) {
        eventsLocations.push(location);
      }
      return null;
    });
    this.setState({ eventsLocations });
  }

  findEventMonths = (updatedEvents) => {
    const eventsMonths = [];
    const MONTH_LABELS = moment().localeData().months();
    let monthObj = null;
    updatedEvents?.forEach((updatedEventItem) => {
      const eventDate = moment(updatedEventItem.event_date_time, DATE_TIME_FORMAT_EVENT);
      const eventMonth = eventDate.month();
      const monthName = MONTH_LABELS[eventMonth];
      const padZero = (num) => (num < 10 ? '0' : '') + num;
      const str = padZero(eventMonth + 1);
      monthObj = { key: str, value: str, label: monthName };

      if (eventsMonths.filter((eventMont) => (eventMont.label === monthObj.label))?.length === 0) {
        eventsMonths.push(monthObj);
      }
    });
    this.setState({ eventsMonths });
  }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  }

  handleShowAll = () => {
    const { $location } = this.props;
    const { showall = '' } = $location.search();
    return showall === 'enabled';
  }

  handleFilterValue = (filterValue) => {
    const { allParsedEventsData } = this.state;
    let filterParsedEventsData = allParsedEventsData.slice(0);

    if (filterValue?.slug && filterValue?.slug !== 'ALL_CITIES') {
      filterParsedEventsData = filterParsedEventsData.filter((parsedEvent) => parsedEvent.location === filterValue?.slug);
    }

    if (filterValue?.status === 1) {
      filterParsedEventsData = filterParsedEventsData.filter((parsedEvent) => !parsedEvent.sold_out && !parsedEvent.is_teaser && !parsedEvent.passed_event);
    }

    if (filterValue?.status === 2) {
      filterParsedEventsData = filterParsedEventsData.filter((parsedEvent) => parsedEvent.is_teaser && !parsedEvent.passed_event);
    }

    if (filterValue?.month > -1) {
      filterParsedEventsData = filterParsedEventsData.filter((parsedEvent) => {
        const eventDate = moment(parsedEvent.event_date_time, DATE_TIME_FORMAT_EVENT);
        const eventMonth = eventDate.month();
        if (eventMonth === filterValue?.month) {
          return parsedEvent;
        }
        return null;
      });
    }

    this.setState({ parsedEventsData: filterParsedEventsData, isFilterEnabled: true });
  };

  fetchData = async (hash) => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const showAllEnabled = this.handleShowAll();

    const contentData = await fetchS3JsonFile(baseRequestUrl, 'Experiential', 'ExperientialData.json');

    if (contentData) {
      const {
        events: {
          hide_section: hideEvents,
        },
        editorials: {
          hide_section: hideEditorials,
        },
        is_events_caching_enabled: isEventsCachingEnabled = false,
      } = contentData;

      this.setState(
        {
          contentData,
          hash,
          showAllEnabled,
        }
      );

      if (!hideEvents) {
        this.fetchEvents(contentData.events, isEventsCachingEnabled);
      }
      if (!hideEditorials) this.fetchEditorials();
    }
  }

  fetchEvents = async (contentData, isEventsCachingEnabled) => {
    const eventsConfig = contentData?.events;
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      selectedCoreSeats,
      selectedCoreISODate,
      selectedCoreTime,
      locationBySlug,
    } = this.props;

    const { showAllEnabled } = this.state;

    const eventsData = await fetchS3JsonFile(baseRequestUrl, 'Experiential', 'ExperientialEvents.json', isEventsCachingEnabled);

    this.setState({
      eventsData,
    });
    if (Object.keys(locationBySlug).length === 0) return;

    let updatedEvents = null;
    if (validateEventsSectionData(eventsConfig)) {
      updatedEvents = await updatedEventsData(eventsData, eventsConfig, selectedCoreSeats, selectedCoreISODate,
        selectedCoreTime, locationBySlug, showAllEnabled);
      const newEvents = findNewEvents(contentData, updatedEvents);

      if (!eventsConfig?.include_new_events) {
        updatedEvents = updatedEvents.filter((eventItem) => !eventItem.isNewEvent);
      }
      this.updateEventsDataState(updatedEvents, newEvents);
    }
  }

  filterPastEvents = (isCuratedPast, events) => {
    let updatedEvents = null;
    // curated past events
    if (isCuratedPast) {
      updatedEvents = events?.slice(0).filter((eventItem) => eventItem.passed_event
      && eventItem.display_as_past_event_id).sort((a, b) => (a.display_as_past_event_id - b.display_as_past_event_id));
    } else {
      // non curated past events
      updatedEvents = events?.slice(0).filter((eventItem) => !eventItem.display_as_past_event_id);
    }
    return updatedEvents;
  }

  updateEventsDataState = (updatedEvents, newEvents) => {
    const {
      locationBySlug,
    } = this.props;
    const eventsData = this.filterPastEvents(false, updatedEvents?.slice(0));
    this.setState({
      parsedEventsData: eventsData,
      allParsedEventsData: eventsData,
      newEvents: this.filterPastEvents(false, newEvents?.slice(0)),
      pastEvents: this.filterPastEvents(true, updatedEvents?.slice(0)),
    });

    // FIND LOCATIONS FROM EVENTS
    this.findEventLocations(eventsData, locationBySlug);
    this.findEventMonths(eventsData);
  }

  fetchEditorials = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    const editorialData = await fetchS3JsonFile(baseRequestUrl, 'Experiential/editorials', 'ExperientialEditorials.json');
    this.setState({ editorialData });
  }

  handleTagging = (eventName, params) => {
    const { Analytics } = this.props;
    handleTaggingWithProps(eventName, Analytics, params);
  };

  setGDAPageCookie = () => {
    this.setState({ gdaCookie: Cookies.get(GDA_COOKIE_NAME) });
  }

  getFilteredEditorialsListLength = (length) => {
    this.setState({ filteredEditorialsListLength: length });
  }

  updateParsedEventData = (eventDetails, type) => {
    const {
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug,
    } = this.props;

    const {
      contentData,
      eventsData,
    } = this.state;

    const {
      cta_label: ctaLabel, display_start_date_offset: startDateOffset,
      display_end_date_offset: endDateOffset, timezone_mappings: timezoneMappings,
    } = contentData?.events;

    const { parsedEventsData, newEvents, pastEvents } = this.state;
    let eventsToUpdate = null;
    if (type === NEW_EVENTS) {
      eventsToUpdate = newEvents;
    } else if (type === PAST_EVENTS) {
      eventsToUpdate = pastEvents;
    } else {
      eventsToUpdate = parsedEventsData;
    }

    const updatedParsedEventData = [];
    eventsToUpdate?.forEach((item) => {
      if (item.event_slug && (item.event_slug === eventDetails?.url_slug)) {
        const eventItem = eventsData.RESY_EVENTS.find((element) => (element.event_slug === eventDetails.url_slug
          && element.venue_slug === eventDetails.venue.url_slug));

        const updatedResyEvent = updateResyEventItem(eventItem, eventDetails, locationBySlug,
          timezoneMappings, selectedCoreSeats,
          selectedCoreISODate, selectedCoreTime);
        updateWithCommonFields(updatedResyEvent, ctaLabel, startDateOffset, endDateOffset, timezoneMappings);

        const parsedCurrentDate = getCurrentMomentDate(updatedResyEvent.timezone, timezoneMappings);
        const {
          display_start_date_time: displayStartDateTime, display_end_date_time: displayEndDateTime,
          display_as_past_event_id: displayAsPastEventId,
        } = updatedResyEvent;
        const parsedStartDate = moment(displayStartDateTime, DATE_TIME_FORMAT);
        const parsedEndDate = moment(displayEndDateTime, DATE_TIME_FORMAT);
        // add the check for display_as_past_event_id
        if (displayAsPastEventId || (!displayAsPastEventId
                && parsedCurrentDate.isSameOrBefore(parsedEndDate)
        && parsedCurrentDate.isSameOrAfter(parsedStartDate))) {
          updatedParsedEventData.push(updatedResyEvent);
        }
      } else {
        updatedParsedEventData.push(item);
      }
    });

    if (type === NEW_EVENTS) {
      const actualEvents = this.filterPastEvents(false, updatedParsedEventData?.slice(0));
      this.setState({ newEvents: actualEvents });
    } else if (type === PAST_EVENTS) {
      const actualEvents = this.filterPastEvents(true, updatedParsedEventData?.slice(0));
      this.setState({ pastEvents: actualEvents });
    } else {
      const actualEvents = this.filterPastEvents(false, updatedParsedEventData?.slice(0));
      this.setState({ parsedEventsData: actualEvents });
    }
  }

  render() {
    const {
      contentData,
      parsedEventsData,
      newEvents,
      editorialData,
      gdaCookie,
      filteredEditorialsListLength,
      showAllEnabled,
      hash,
      eventsLocations,
      eventsMonths,
      isFilterEnabled,
      pastEvents,
    } = this.state;
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      $rootScope: {
        matchMedia,
      },
      $location,
      $rootScope,
      $routeParams,
      Analytics,
      isAuthenticated,
      isUserLoggedInAsGDA,
      isNonUS,
      selectedCoreSeats,
      selectedLocation,
    } = this.props;
    const isNonUSLocation = isNonUS || false;

    const renderLoading = (
      <div>
        <Loader className="AmexExperiential__loader" />
      </div>
    );

    if (!contentData) return renderLoading;

    const {
      header: headerConfig,
      banner: bannerConfig,
      events: eventsConfig,
      newevents: newEventsConfig,
      pastevents: pastEventsConfig,
      email_opt_in: emailOptInConfig,
      editorials: editorialsConfig,
      naa: naaConfig,
      mgm: mgmConfig,
      is_page_enabled: isPageEnabled,
      tagging: taggingConfig,
      terms: termsConfig,
      is_filter_config_enabled: isFilterConfigEnabled,
    } = contentData;

    const {
      hide_section: hideEvents,
    } = eventsConfig;

    const hideNewEvents = newEventsConfig?.hide_section;
    const hidePastEvents = pastEventsConfig?.hide_section;

    if (!isPageEnabled) {
      // 404 error page
      $location.path('/404');
      $rootScope.$digest();
      return null;
    }
    let isGDA = false;
    if (isUserLoggedInAsGDA || gdaCookie === GDA_MEMBER || gdaCookie === GDA_ELIGIBLE) {
      isGDA = true;
    }
    const hideEditorials = editorialsConfig?.hide_section || (editorialData && Object.keys(editorialData)?.length === 0) || filteredEditorialsListLength === 0;
    const hideEmailOptIn = emailOptInConfig?.hide_section;
    const editorialsImagePath = `${baseRequestUrl}Experiential/`;
    const editorialsSectionId = editorialsConfig?.section_id;
    const hideNAA = contentData?.naa.hide_section || isGDA;
    const hideMGM = contentData?.mgm.hide_section || !isGDA;

    const timeLimitSelector = contentData?.limit_selector_time;
    const dateLimitSelector = contentData?.limit_selector_date;

    return (
      <div className="AmexExperiential">
        <AmexHeader
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          isNonUSLocation={isNonUSLocation}
          $rootScope={$rootScope}
          $routeParams={$routeParams}
          $location={$location}
          matchMedia={matchMedia}
          tagConfig={taggingConfig}
          dateLimitSelector={dateLimitSelector}
          timeLimitSelector={timeLimitSelector}
        />
        <AmexExperientialHeader
          baseRequestUrl={baseRequestUrl}
          headerConfig={headerConfig}
          Analytics={Analytics}
          isNonUSLocation={isNonUSLocation}
          hideNewEvents={hideNewEvents || !newEvents || newEvents?.length === 0}
          hideEvents={hideEvents || !parsedEventsData}
          hidePastEvents={hidePastEvents || !pastEvents || pastEvents?.length === 0}
          hideEditorials={hideEditorials}
          hideNAA={hideNAA}
          matchMedia={matchMedia}
          locationSlug={selectedLocation?.url_slug}
          scrollTo={scrollTo}
        />
        <AmexExperientialBanner
          bannerConfig={bannerConfig}
          matchMedia={matchMedia}
          baseRequestUrl={baseRequestUrl}
          Analytics={Analytics}
          scrollTo={scrollTo}
        />
        {/* NEW EVENTS */}
        {!hideNewEvents && newEvents?.length > 0 && (
        <AmexExperientialEvents
          eventsData={newEvents}
          baseRequestUrl={baseRequestUrl}
          eventsConfig={eventsConfig}
          newEventsConfig={newEventsConfig}
          Analytics={Analytics}
          isDesktop={matchMedia.md}
          isAuthenticated={isAuthenticated}
          $rootScope={$rootScope}
          selectedCoreSeats={selectedCoreSeats}
          updateParsedEventData={this.updateParsedEventData}
          matchMedia={matchMedia}
          showAllEnabled={showAllEnabled}
          displaySection={NEW_EVENTS}
        />
        )}
        {!hideEvents && !parsedEventsData && (
          <div>
            <Loader className="AmexExperiential__events" />
          </div>
        )}
        {/* MAIN EVENTS */}
        {!hideEvents && parsedEventsData && eventsLocations && eventsMonths && (
          <AmexExperientialEvents
            eventsData={parsedEventsData}
            baseRequestUrl={baseRequestUrl}
            eventsConfig={eventsConfig}
            Analytics={Analytics}
            isDesktop={matchMedia.md}
            isAuthenticated={isAuthenticated}
            $rootScope={$rootScope}
            selectedCoreSeats={selectedCoreSeats}
            updateParsedEventData={this.updateParsedEventData}
            matchMedia={matchMedia}
            showAllEnabled={showAllEnabled}
            displaySection={MAIN_EVENTS}
            handleFilterValue={this.handleFilterValue}
            eventsLocations={eventsLocations}
            eventsMonths={eventsMonths}
            isFilterEnabled={isFilterEnabled}
            isFilterConfigEnabled={isFilterConfigEnabled}
          />
        )}
        {/* PAST EVENTS */}
        {!hidePastEvents && pastEvents?.length > 0 && (
          <AmexExperientialEvents
            eventsData={pastEvents}
            baseRequestUrl={baseRequestUrl}
            eventsConfig={eventsConfig}
            pastEventsConfig={pastEventsConfig}
            Analytics={Analytics}
            isDesktop={matchMedia.md}
            isAuthenticated={isAuthenticated}
            $rootScope={$rootScope}
            selectedCoreSeats={selectedCoreSeats}
            matchMedia={matchMedia}
            showAllEnabled={showAllEnabled}
            displaySection={PAST_EVENTS}
            updateParsedEventData={this.updateParsedEventData}
          />
        )}
        {!isNonUSLocation && (
          <>
            {!hideNAA && (
              <AmexExperientialNAA
                baseRequestUrl={baseRequestUrl}
                naaConfig={naaConfig}
                Analytics={Analytics}
                matchMedia={matchMedia}
              />
            )}
            {!hideMGM && (
              <AmexExperientialMGM
                baseRequestUrl={baseRequestUrl}
                mgmConfig={mgmConfig}
                Analytics={Analytics}
              />
            )}
          </>
        )}
        {!hideEmailOptIn && (
          <AmexExperientialEmailOptIn
            emailOptInConfig={emailOptInConfig}
            Analytics={Analytics}
          />
        )}
        {!hideEditorials && (
          <AmexMarketingEditorials
            editorialData={editorialData}
            editorialsImagePath={editorialsImagePath}
            editorialsSectionId={editorialsSectionId}
            Analytics={Analytics}
            getFilteredEditorialsListLength={this.getFilteredEditorialsListLength}
          />
        )}
        <AmexTerms
          baseRequestUrl={baseRequestUrl}
          hash={hash}
          termsConfig={termsConfig}
          Analytics={Analytics}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    selectedCoreISODate, selectedCoreSeats, selectedCoreTime,
  } = state.resyCore;

  const {
    bySlug: locationBySlug,
    selected: selectedLocation,
  } = state.resyLocations;

  return {
    isUserLoggedInAsGDA: selectIsGlobalDiningAccess(state),
    locationBySlug,
    selectedCoreISODate,
    selectedCoreSeats,
    selectedCoreTime,
    selectedLocation,
    isAuthenticated: selectIsAuthenticated(state),
    favoriteVenues: state.favorite,
    isNonUS: state.ipdata?.isNonUS,
  };
};

AmexExperiential.displayName = 'AmexExperiential';
export { AmexExperiential as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexExperiential);
